import { RouteObject } from "react-router-dom";
import ProdutoView from "./Produto/Produto.View";
import ProdutoCadastroView from "./Produto/Cadastro/ProdutoCadastro.View";
import CategoriasView from "./Categorias/Categorias.View";
import CategoriasCadastroView from "./Categorias/Cadastro/CategoriasCadastro.View";

export const EstoqueRoutes: RouteObject[] = [
  {
    path: "estoque/produtos",
    element: <ProdutoView />,
  },
  {
    path: "estoque/produtos/cadastro",
    element: <ProdutoCadastroView />,
  },
  {
    path: "estoque/produtos/categorias",
    element: <CategoriasView />,
  },
  {
    path: "estoque/produtos/categorias/cadastro",
    element: <CategoriasCadastroView />,
  },
];
